import { createActions } from 'redux-actions';

import types from 'state/clientConfig/actionTypes';

const { clientConfig } = createActions({
  [types.SET_CLIENT_CONFIG]: (clientConfig = {}) => ({ clientConfig }),
});

export default clientConfig;
